<script lang="ts">
  import { CreateUUID } from "../../shared/Utils";
  import { userbaseStore, ArticleStore } from "../../stores/stores";
  import { createEventDispatcher } from "svelte";
  import Button from "../../shared/Button.svelte";
  import Input from "../../shared/Input.svelte";
  import type { Article } from "../../stores/types";
  import { ArticleType, DatabaseName } from "../../stores/types";

  let dispatch = createEventDispatcher();
  let newArticle = { name: "", type: ArticleType.MEHL };
  let addPromise = null;
  const databaseNameArticle = DatabaseName.ARTICLES.toString();
  const databaseNameLogs = DatabaseName.INVENTORYLOG.toString();

  const artcleTypes = Object.entries(ArticleType);

  const submitHandler = () => {
    // add new article in DB
    let Guid = CreateUUID();
    let entry: Article = { ...newArticle };
    addPromise = $userbaseStore.insertItem({
      databaseName: databaseNameArticle,
      item: entry,
      itemId: Guid,
    });
    // update store
    ArticleStore.update((currentArticles) => {
      return [{ item: entry, itemId: Guid }, ...currentArticles];
    });

    // log entry
    var logItem = {
      dbname: "article",
      action: "add",
      changedItem: { itemId: Guid, item: entry },
    };
    addPromise = $userbaseStore.insertItem({
      databaseName: databaseNameLogs,
      item: logItem,
    });
    dispatch("addArticle");
  };
</script>

<form on:submit|preventDefault={submitHandler}>
  <h2>Neuer Artikel</h2>
  <Input label="Name:" bind:value={newArticle.name} type="text" required />
  <select bind:value={newArticle.type}>
    {#each artcleTypes as entry}
      <option value={entry[1]}>{entry[1]}</option>
    {/each}
  </select>

  <Button type="secondary" flat={true}>Neue Artikel hinzufügen</Button>
</form>
